import { MeasurementPlan, MeasurementVariant } from '../../../shared/types/protocol.ts';


// Returns true, if the measurement plan is valid and shows an alert if not
export function createPlanOrAlert(
    fallbackInterval: string,
    variantSequence: string,
    variants: MeasurementVariant[],
): MeasurementPlan | null {

    let parsedInterval: number | null = null;
    if (fallbackInterval) {
        parsedInterval = parseFallbackInterval(fallbackInterval);
        if (parsedInterval == null) {
            alert('Fallback interval must be in the following format: 4h 30m.');
            return null;
        }

        if (parsedInterval <= 0) {
            alert('Fallback interval must be positive.');
            return null;
        }
    }

    const variantSequenceFinal = variantSequence.replace(/\s+/g, '').toUpperCase();
    if (variantSequenceFinal) {
        if (!variantSequenceFinal.startsWith('A')) {
            alert(`Variant sequence must start with 'A'.`);
            return null;
        }

        const validVariantNames = ['A', 'B', 'C'];
        for (const char of variantSequenceFinal) {
            if (!validVariantNames.includes(char)) {
                alert(`Variant sequence can only contain the following characters: ${validVariantNames.join(', ')}.`);
                return null;
            }
        }

        for (const variant of variants) {
            if (!variantSequenceFinal.includes(variant.name)) continue;

            const hasRealCount = Object.values(variant.positions).some(count => count > 0);
            if (!hasRealCount) {
                alert(`Sequence contains a measurement variant without any position measurements.`);
                return null;
            }
        }
    }

    const measurementPlan: MeasurementPlan = {
        ...(parsedInterval && { fallbackIntervalMs: parsedInterval }),
        ...(variantSequenceFinal && { variantSequence: variantSequenceFinal }),
        variants,
    };
    return measurementPlan;
}

function parseFallbackInterval(input: string): number | null {
    const match = input.match(/^(\d{1,2})h\s*((\d{1,2})m)?$/);
    if (!match) return null;

    const hours = parseInt(match[1], 10);
    const minutes = match[3] ? parseInt(match[3], 10) : 0;

    return hours * 60 * 60 * 1000 + minutes * 60 * 1000;
}
